import { APIError } from '@/interfaces/error';

export class ServiceAccessError extends Error {
  constructor(message: APIError) {
    super(JSON.stringify(message));
    this.name = `ServiceAccessError`;
  }
}
